/****DROPPED-ELEMENT-POSITION-DEFINE****/
$(document).on('click touch', '*[data-drop-position]', function(event){
	var wS = $(window).scrollTop(),
		wH = $(window).height(),
		wW = $(window).width(),

		target = $(this).attr('data-drop'),
		item = $('#'+target),
		iHeight = $('#' + target).height(),
		iHeight = item.outerHeight(),
		iWidth = item.outerWidth(),

		eCoord = $(this).offset(),
		eTop = eCoord['top'],
		eLeft = eCoord['left'],
		ePosTop = eTop - wS,
		eWidth = $(this).outerWidth();


	/**********VERTICAL-POSITION-DEFINE*************/
	/************drop-down***********/
	if((wH - ePosTop) > iHeight){
		item
		.addClass('under')
		.removeClass('above')
	}
	/************drop-up***********/
	else if ((wH - ePosTop) <= iHeight && ePosTop > iHeight ){
		item
		.addClass('above')
		.removeClass('under')
	}
	/***********drop-neutral*****************/
	else if ((wH - ePosTop) <= iHeight && ePosTop < iHeight) {
		item
		.addClass('under')
		.removeClass('above')
	}
	/**************HORIZONTAL-POSITION**************/

	if(wW - eLeft >= iWidth){
		item
		.addClass('right')
		.removeClass('left')
	}
	else {
		item
		.addClass('left')
		.removeClass('right')
	}

});
/****POPOVER-ELEMENT-POSITION-DEFINE****/
function definePoistion(element, target, type){
	var wS = $(window).scrollTop(),
		wH = $(window).height(),
		wW = $(window).width(),

		eHeight = element.outerHeight(),
		eWidth = element.outerWidth(),
		eCoord = element.offset(),
		eTop = eCoord['top'],
		eLeft = eCoord['left'],
		ePosTop = eTop - wS,

		item  = $("#"+target),
		iHeight = item.outerHeight(),
		iWidth = item.outerWidth(),

		indent;
		if(element.parents('.txt').length){
			indent = 7
		}
		else {
			indent = 15;
		}
	/*************VERTICAL-POSITION-DEFINE*************/
	/************drop-up***********/
	if(ePosTop >= iHeight){
		item
		.addClass('above')
		.removeClass('under')
		.css({
			'top': eTop - iHeight - indent +'px'
		});

	}
	/************drop-down***********/
	else if (ePosTop < iHeight && (wH - ePosTop) > iHeight ){
		item
		.addClass('under')
		.removeClass('above')
		.css({
			'top': eTop + eHeight + indent +'px'
		});
	}
	/*********drop-neutral*************/
	else if ((wH - ePosTop) <= iHeight && ePosTop < iHeight) {
		item
		.addClass('under')
		.removeClass('above')
		.css({
			'top': eTop + eHeight + indent +'px'
		});
	}

	/**************HORIZONTAL-POSITION-DEFINE**************/
	if(type == 'tooltip'){
		item.css({
			'left': ((eLeft + eWidth/2) - iWidth/2) +'px'
		})
	}
	else if(type == 'popover') {
		if(eLeft + iWidth <= wW) {
			item
			.removeClass('left')
			.addClass('right')
			.css({
				'left': eLeft + 'px'
			})
		}
		else if (eLeft + iWidth > wW && eLeft + eWidth >= iWidth){
			item
			.removeClass('right')
			.addClass('left')
			.css({
				'left': (eLeft + eWidth - iWidth) + 'px'
			})
		}
		else if (eLeft + iWidth > wW && eLeft + eWidth < iWidth){
			item
			.removeClass('right')
			.addClass('left')
			.css({
				'max-width': (eLeft + eWidth)+'px',
				'left': (eLeft + eWidth - iWidth) + 'px'
			})
		}

	}
}